'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasBody = exports.isRestfulPost = exports.replace = exports.getParams = exports.toSet = exports.toHttpMethods = exports.upper = exports.ofType = exports.attachDefault = exports.parsePath = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var find = function find(a, p, v, c) {
  var idx = a.findIndex(function (x) {
    return (0, _ramda.is)(Object, x) ? c ? x[p] == v : x[p] === v : c ? x == v : x === v;
  });

  if (idx === -1) return new Error('Item not found with \'' + p + '=' + v + '\'');

  return idx;
};

var findWithParam = function findWithParam(a, p1, p2, params) {
  var v = params && params[p2];

  if ((0, _ramda.isNil)(v)) return a.length;

  return find(a, p1, v);
};

var getIndex = function getIndex(arr, prop, params) {
  var ps = prop.split('=').map(function (x) {
    return x.trim();
  });
  var propName = replace(ps[0], params);

  if (ps.length > 2) // [id=5=a]
    throw new Error('Invalid path \'' + prop + '\'');else if (ps.length > 1) {
    var pp = getParams(ps[1]);

    if (pp.length === 0) // [id=5], [{name}=a]
      return find(arr, propName, ps[1], true);else if (pp.length === 1 && ps[1] === '{' + pp[0] + '}') // [id={ID}]
      return findWithParam(arr, propName, pp[0], params);else // [id={id}1], [id={id1}{id2}]
      return find(arr, propName, replace(ps[1], params), true);
  } else // [id]
    return findWithParam(arr, propName, propName, params);
};

var parsePath = exports.parsePath = function parsePath(path, name, method) {
  if (!path) path = name;

  var lens = path.split('.').map(function (x) {
    if ((0, _ramda.last)(x) !== ']') return x;

    var m = x.match(/(.+)\[(.*)\]/);
    if (!m) return x;

    var _m = _slicedToArray(m, 3),
        _ = _m[0],
        arrName = _m[1],
        prop = _m[2];

    if (!arrName) throw new Error('invalid path "' + path + '"');

    return [arrName, prop];
  });

  return function (params, state, statusCode) {
    if (lens.length > 0 && (0, _ramda.is)(String, (0, _ramda.last)(lens)) && isRestfulPost(method, statusCode)) // restful post to array
      lens[lens.length - 1] = [(0, _ramda.last)(lens), ''];

    return (0, _ramda.reduce)(function (p, c) {
      if (!(0, _ramda.is)(Array, c)) return [].concat(_toConsumableArray(p), [replace(c, params)]);

      var arrName = replace(c[0], params);
      var prop = c[1];

      var arr = (0, _ramda.view)((0, _ramda.lensPath)([].concat(_toConsumableArray(p), [arrName])), state);
      var idx = null;

      if (!arr && prop === '') idx = 0;else if (!(0, _ramda.is)(Array, arr)) throw new Error(arrName + ' is not an array');else if (prop === '') idx = arr.length;else if (!Number.isNaN(+prop)) idx = +prop;else idx = getIndex(arr, prop, params);

      if (idx === -1) idx = new Error('Item not found with \'' + prop + '\'');

      return [].concat(_toConsumableArray(p), [arrName, idx]);
    }, [], lens);
  };
};

var attachDefault = exports.attachDefault = (0, _ramda.merge)({
  error: {},
  isLoading: {}
});

var ofType = exports.ofType = function ofType(a, as) {
  return as.filter(function (x) {
    return x.type === a.toString();
  });
};

var upper = exports.upper = function upper(x) {
  return (0, _ramda.is)(String, x) && x.length > 0 ? x[0].toUpperCase() + x.slice(1) : '';
};

var toHttpMethods = exports.toHttpMethods = function toHttpMethods(x, a) {
  if (a && a.methods && !((0, _ramda.is)(Array, a.methods) && (0, _ramda.all)((0, _ramda.is)(String), a.methods))) throw new Error('\'methods\' property must be a list of strings');

  if (a && a.method && !(0, _ramda.is)(String, a.method)) throw new Error('\'method\' property must be a string');

  return (a && a.methods || [a && a.method || 'get']).map(function (m) {
    return [(0, _ramda.toLower)(m), (0, _ramda.toLower)(m) + upper(x)];
  });
};

var toSet = exports.toSet = function toSet(x) {
  return 'set' + upper(x);
};

var getParams = exports.getParams = function getParams(s) {
  return (s.match(/{(.*?)}/g) || []).map(function (x) {
    return x.match(/{(.*)}/)[1];
  });
};

var replace = exports.replace = function replace(s, params) {
  if (params && (0, _ramda.is)(Object, params)) {
    s = (0, _ramda.reduce)(function (p, c) {
      return p.replace(new RegExp('\\{' + c + '\\}', 'g'), params[c]);
    }, s, Object.keys(params));
  }

  var ps = getParams(s);

  if (ps.length > 0) throw new Error(ps.join(', ') + ' ' + (ps.length > 1 ? 'are' : 'is') + ' not provided');

  return s;
};

var isRestfulPost = exports.isRestfulPost = function isRestfulPost(method, statusCode) {
  return method === 'post' && statusCode === 201;
};

var hasBody = exports.hasBody = function hasBody(method) {
  return (0, _ramda.contains)(method, ['post', 'put', 'patch']);
};


//////////////////
// WEBPACK FOOTER
// D:/Code/Lynqu/npm/no-redux/dist/common.js
// module id = 72
// module chunks = 0